import {
  CLEAR_STATE,
  CLEAR_SUGGESTEDPF,

  SAVE_SUGGESTEDPF,
  SAVE_SUGGESTEDPF_ERROR,
  SAVE_SUGGESTEDPF_SUCCESS,

  GET_SUGGESTEDPF_BY_DATE,
  GET_SUGGESTEDPF_BY_DATE_ERROR,
  GET_SUGGESTEDPF_BY_DATE_SUCCESS,

  DELETE_SUGGESTEDPF,
  DELETE_SUGGESTEDPF_ERROR,
  DELETE_SUGGESTEDPF_SUCCESS,

  GET_TRANSACTION_PF,
  GET_TRANSACTION_PF_SUCCESS,
  GET_TRANSACTION_PF_ERROR,

  GET_SUGGESTED_PF,
  GET_SUGGESTED_PF_ERROR,
  GET_SUGGESTED_PF_SUCCESS,
} from './constants';

export default {
  [CLEAR_SUGGESTEDPF](state) {
    state.suggestedprovident = {
      date: false,
      amount: false,
    };
  },
  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_SUGGESTEDPF](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_SUGGESTEDPF_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_SUGGESTEDPF_SUCCESS](state) {
    state.suggestedprovident = false;
    state.loading = false;
  },

  [SAVE_SUGGESTEDPF](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
  },
  [SAVE_SUGGESTEDPF_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [SAVE_SUGGESTEDPF_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.suggestedprovident = payload;
  },

  [GET_SUGGESTEDPF_BY_DATE](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_SUGGESTEDPF_BY_DATE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_SUGGESTEDPF_BY_DATE_SUCCESS](state, payload) {
    state.suggestedprovident = payload;
    state.loading = false;
  },

  [GET_TRANSACTION_PF](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_TRANSACTION_PF_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_TRANSACTION_PF_SUCCESS](state, payload) {
    state.transactionSPA = payload;
    state.loading = false;
  },

  [GET_SUGGESTED_PF](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_SUGGESTED_PF_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_SUGGESTED_PF_SUCCESS](state, payload) {
    state.suggestedPF = payload;
    state.loading = false;
  },


  // single object item mutation
  updateItem(state, payload) {
    state.suggestedprovident[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/SuggestedPF/mutations.js